<template>
  <div class="d-flex align-items-center mb-6">
    <v-btn
        v-if="onBack"
        @click="onBack"
        icon
        class="me-2">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <h1 class="page-title">{{ text }}</h1>
  </div>
</template>

<script>
export default {
  name: "dashboard-header",
  props: ["text", "onBack"],
}
</script>

<style scoped>
.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #1F2937;
  margin: 0;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 20px;
  }
}
</style>